module.exports = "<div id=inbox> <title title=Inbox></title> <div v-if=$loadingAsyncData class=\"mdl-spinner mdl-js-spinner is-active\"></div> <list v-if=!$loadingAsyncData :mails=mails></list> <create></create> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Inbox.vue
 ** module id = 27
 ** module chunks = 0
 **/